import { render, staticRenderFns } from "./VvPopup.vue?vue&type=template&id=54acefc0"
import script from "./VvPopup.vue?vue&type=script&lang=js"
export * from "./VvPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports